import { Row, Col, Button, Card, Form } from 'react-bootstrap';
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";
import React, { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Toast from 'react-bootstrap/Toast';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import setting from '../../setting.json';

const schema = yup.object().shape({

    fname: yup.string().required("Please enter value"),
    father_fname: yup.string().required("Please enter value"),
    mother_fname: yup.string().required("Please enter value"),
    dob: yup.string().required("Please enter value"),
    gender: yup.string().required("Please select value"),
    category: yup.string().required("Please select value"),
    religion: yup.string().required("Please select value"),
    marital: yup.string().required("Please select value"),
    mobile: yup.number().required("Please enter value"),
    adhar_num: yup.number().required("Please enter value"),
    email: yup.string().email().required("Please enter value"),
    address: yup.string().required("Please enter value"),
    state: yup.string().required("Please select value"),
    city: yup.string().required("Please select value"),
    district: yup.string().required("Please enter value"),
    pincode: yup.number().required("Please enter value"),
    handicap: yup.string().required("Please enter value"),

    course: yup.string().required("Please select value"),
    major_subfirst: yup.string().required("Please select value"),
    major_secund: yup.string().required("Please select value"),
    major_theard: yup.string().required("Please select value"),
    minor_sub: yup.string().required("Please select value"),
    cocurricular_sub: yup.string().required("Please select value"),
    vocational_sub: yup.string().required("Please select value"),
    tc: yup.string().required("Please select value"),
    // income_amount: yup.string().required("Please select value"),
    // caste_no: yup.string().required("Please select value"),
    // issue_date: yup.string().required("Please select value"),
    // dis_type: yup.string().required("Please select value"),


    // Documents

    highschool: yup.string(),
    inter: yup.string(),
    photo: yup.string(),
    adhar: yup.string(),
    signature: yup.string(),



    // income: yup.string().when('category', {
    //     is: (val) => val && val !== '',
    //     then: (schema) => schema.required('Please upload income certificate'),
    //     otherwise: (schema) => schema.notRequired(),
    // }),

    // domicile: yup.string().when('category', {
    //     is: (val) => val && val !== '',
    //     then: (schema) => schema.required('Please upload domicile certificate'),
    //     otherwise: (schema) => schema.notRequired(),
    // }),

    // caste: yup.string().when('category', {
    //     is: (val) => val && val !== '',
    //     then: (schema) => schema.required('Please upload caste certificate'),
    //     otherwise: (schema) => schema.notRequired(),
    // }),




});

const AdmissionForm = () => {

    const navigate = useNavigate()
    const [add, setAdd] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [subDistrictList, setSubDistrictList] = useState([]);
    const [coursecList, setCoursecList] = useState([]);
    const [majorList, setMajorList] = useState([]);
    const [minorList, setMinorList] = useState([]);
    const [vo_courseList, setVo_courseList] = useState([]);
    const [curricularSubject, setCoCurricularSubject] = useState([]);
    const [mode, setMode] = useState('')

    const {
        register,
        handleSubmit,
        reset,
        setError,
        unregister,
        watch,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),

    })


    const [toast, setToast] = useState()
    const toaster = useRef(null)

    const selectedTC = watch('tc');

    const selectedCategory = watch('category');
    const selectedHandicap = watch('handicap');

    // Unregister multiple fields when category is deselected
    useEffect(() => {
        if (!selectedCategory) {
            unregister(['income', 'domicile', 'caste']);
        }
        else if (!selectedHandicap) {
            unregister('dis_type');
        }
        else if (!selectedTC) {
            unregister('transfer');
        }
        console.log(selectedCategory);
    }, [selectedCategory, unregister, selectedHandicap, selectedTC]);



    const getToast = (message, type = 'success') => (
        <Toast autohide={true} visible={true} delay={3000}>
            <Toast.Header closeButton>
                <svg className="rounded me-2" width="20" height="20">
                    <rect width="100%" height="100%" fill={type === 'success' ? '#28a745' : '#dc3545'}></rect>
                </svg>
                <strong className="me-auto">{type === 'success' ? 'Success' : 'Error'}</strong>
                <small>Now</small>
            </Toast.Header>
            <Toast.Body>{message}</Toast.Body>
        </Toast>
    );


    const getAllMajorSubjectByCourse = async (e) => {

        var id = e.target.value;
        console.log(id);

        await fetch(setting.api + 'student/getAllMajorSubjectByCourse?id=' + id, {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(cm => {
                setMajorList(cm.data);
            });


        await fetch(setting.api + 'student/getAllMinorSubjectByCourse?id=' + id, {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(cm => {
                setMinorList(cm.data);
            });

        await fetch(setting.api + 'student/getCoCurricularSubjectByCourse?id=' + id, {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(cm => {
                setCoCurricularSubject(cm.data);
            });
    }

    const getDistrictByStateId = async (e) => {
        var id = e.target.value;
        console.log(id);
        await fetch(setting.api + 'student/getDistrictByStateId?id=' + id, {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(cm => {
                setCityList(cm.data);
            });
    }

    const getSubDistrictByDistrictId = async (e) => {
        var id = e.target.value;
        await fetch(setting.api + 'student/getSubDistrictByDistrictId?id=' + id, {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(cm => {
                setSubDistrictList(cm.data);
            });
    }

    const getAllVocationalSubject = async () => {

        await fetch(setting.api + 'student/getAllVocationalSubject', {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(sd => {
                setVo_courseList(sd.data);
                console.log(sd.data);
            });
    }
    const getAllState = async () => {

        await fetch(setting.api + 'student/getAllState', {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(sd => {
                setStateList(sd.data);
            });
    }

    const getAllCourse = async () => {
        await fetch(setting.api + 'student/getAllCourse', {
            method: "GET",
            mode: "cors",
        })
            .then(response => response.json())
            .then(u => {
                setCoursecList(u.data);
                console.log(u.data);
            });
    }


    useEffect(() => {
        getAllVocationalSubject();
        getAllState();
        getAllCourse();

    }, []);

    const saveApplicant = async (data) => {
        const fileList = document.getElementById('fileInput').files;
        const fileList1 = document.getElementById('fileInput1').files;
        const fileList2 = document.getElementById('fileInput2').files;
        const fileList3 = document.getElementById('fileInput3').files;
        const fileList4 = document.getElementById('fileInput4').files;
        // const fileList5 = document.getElementById('fileInput5').files;
        // const fileList6 = document.getElementById('fileInput6').files;
        // const fileList7 = document.getElementById('fileInput7').files;


        const files = Array.from(fileList);
        const files1 = Array.from(fileList1);
        const files2 = Array.from(fileList2);
        const files3 = Array.from(fileList3);
        const files4 = Array.from(fileList4);
        // const files5 = Array.from(fileList5);
        // const files6 = Array.from(fileList6);
        // const files7 = Array.from(fileList7);

        let db = new FormData();


        db.append('fname', data.fname);
        db.append('father_fname', data.father_fname);
        db.append('mother_fname', data.mother_fname);
        db.append('dob', data.dob);
        db.append('gender', data.gender);
        db.append('adhar_num', data.adhar_num);
        db.append('mobile', data.mobile);
        db.append('email', data.email);
        db.append('category', data.category);
        db.append('religion', data.religion);
        db.append('marital', data.marital);
        db.append('address', data.address);

        db.append('city', data.city);
        db.append('state', data.state);
        db.append('district', data.district);
        db.append('pincode', data.pincode);
        db.append('handicap', data.handicap);

        db.append('course', data.course);

        db.append('tc', data.tc);
        db.append('major_subfirst', data.major_subfirst);
        db.append('major_secund', data.major_secund);
        db.append('major_theard', data.major_theard);
        db.append('minor_sub', data.minor_sub);
        db.append('cocurricular_sub', data.cocurricular_sub);
        db.append('vocational_sub', data.vocational_sub);


        if (selectedHandicap === 'Yes') {

            db.append('dis_type', data.dis_type);
        }

        db.append('highschool', files[0]);
        db.append('inter', files1[0]);
        db.append('photo', files2[0]);
        db.append('adhar', files3[0]);
        db.append('signature', files4[0]);

        if (selectedTC === 'Available') {
            db.append('transfer', data.transfer[0]);

        }

        if (selectedCategory === 'GEN-EWS') {
            db.append('income', data.income[0]);
            db.append('income_amount', data.income_amount);
        }
        db.append('domicile', data.domicile[0]);

        if (selectedCategory === 'SC' || selectedCategory === 'ST' || selectedCategory === 'OBC') {
            db.append('caste', data.caste[0]);
            db.append('caste_no', data.caste_no);
            db.append('issue_date', data.issue_date);

        }


        console.log(db);

        await fetch(setting.api + 'student/saveApplicant', {
            body: db,
            method: "post",
            mode: "cors",
            headers: {
                // "Authorization": 'Bearer ' + JSON.parse(secureLocalStorage.getItem("logininfo")).token,
            },

        })
            .then(response => response.json())
            .then(u => {

                if (u.result === "failure") {
                    setToast(getToast(u.message || 'Admission Form Submission failed.', 'error'));
                    setError("adhar_num", { type: "string", message: "Aadhar and email should be unique" }, { shouldFocus: true });
                    setError("email", { type: "string", message: "Aadhar and email should be unique" });


                }
                else if (u.result === "success") {
                    setToast(getToast('Admission Form Submitted'));
                    const id = u.data.id;
                    const name = u.data.name;
                    const father = u.data.father;
                    const application = u.data.application_no;

                    navigate('/payment', {
                        state: {
                            id,
                            name,
                            father,
                            application
                        }
                    }
                    )


                }

                else {

                    setToast(getToast(u.message || 'Password change failed.', 'error'));
                }



            });

    }
    return (
        <div className="student-page">
            <Header />
            <header className="height-75">
                <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
                    <h1 className="text-center fw-semibold">Admission Form</h1>
                </div>
            </header>
            <div className="container my-5">
                <div className="row">
                    <div className="col-lg-12 d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
                        <h4 className="mb-4 mb-lg-5" style={{ alignSelf: "center" }}>
                            <b>Admission Form for the A.Y. 2025-26</b>
                        </h4>

                        <h5 className="mb-4 mb-lg-5" style={{ alignSelf: "center" }}>
                            <b>B.A/ B.Sc/ M.A Course</b>
                        </h5>

                    </div>
                    <div className="cart-checkout-box mb-widget">

                        <Form
                            className="Row g-3"
                            onSubmit={handleSubmit(saveApplicant)}
                        >

                            <Card className="mb-4">
                                <Card.Header><strong>Personal Information</strong></Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col xs={12} md={3} >
                                            {/* <Form.Label ><b>Applicant Name</b></Form.Label> */}

                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Applicant Name"
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    {...register("fname")}
                                                    placeholder='Enter First Name'
                                                />
                                            </FloatingLabel>
                                            {errors.fname && <p>{errors.fname.message}</p>}
                                        </Col>


                                        <Col xs={12} md={3}>
                                            {/* <Form.Label ><b>Father Name</b></Form.Label> */}

                                            <FloatingLabel
                                                controlId="floatingInput"
                                                label="Father Name"
                                                className="mb-3"
                                            >
                                                <Form.Control
                                                    type="text"
                                                    {...register("father_fname")}
                                                    placeholder='Enter Father Name'

                                                /></FloatingLabel>
                                            {errors.father_fname && <p>{errors.father_fname.message}</p>}
                                        </Col>

                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>

                                                {/* <Form.Label ><b>Mother Name</b></Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Mother Name"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        {...register("mother_fname")}
                                                        placeholder='Enter Mother Name'

                                                    />
                                                </FloatingLabel>
                                                {errors.mother_fname && <p>{errors.mother_fname.message}</p>}
                                            </div>
                                        </Col>




                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>

                                                {/* <Form.Label ><b>Date of Birth</b> </Form.Label> */}

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Date of Birth"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="date"
                                                        {...register("dob")}
                                                        placeholder='Select Date of Birth'

                                                    /></FloatingLabel>
                                                {errors.dob && <p>{errors.dob.message}</p>}

                                            </div>
                                        </Col>




                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Physical Handicaped</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Physical Handicaped"
                                                    className="mb-3"
                                                >
                                                    <Form.Select   {...register("handicap")}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                    </Form.Select></FloatingLabel>
                                                {errors.handicap && <p>{errors.handicap.message}</p>}

                                            </div>
                                        </Col>

                                        {selectedHandicap === "Yes" && (
                                            <Col xs={12} md={3}>
                                                <div className='mb-3'>

                                                    {/* <Form.Label ><b>Mother Name</b></Form.Label> */}
                                                    <FloatingLabel
                                                        controlId="floatingInput"
                                                        label="Disability Type & (%)"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            {...register("dis_type")}
                                                            placeholder='Enter Disability Type & Percentage'

                                                        />
                                                    </FloatingLabel>
                                                    {errors.dis_type && <p>{errors.dis_type.message}</p>}
                                                </div>
                                            </Col>

                                        )}



                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Gender</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Gender"
                                                    className="mb-3"
                                                >
                                                    <Form.Select   {...register("gender")}
                                                    >
                                                        <option value="">Select Gender</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                        <option value="Other">Other</option>
                                                    </Form.Select></FloatingLabel>

                                                {errors.gender && <p>{errors.gender.message}</p>}
                                            </div>
                                        </Col>




                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Category</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Category"
                                                    className="mb-3"
                                                >
                                                    <Form.Select {...register("category")}
                                                    >
                                                        <option value="">Select Category</option>
                                                        <option value="General">General</option>
                                                        <option value="SC">SC</option>
                                                        <option value="ST">ST</option>
                                                        <option value="OBC">OBC</option>
                                                        <option value="GEN-EWS">GEN-EWS</option>
                                                    </Form.Select></FloatingLabel>
                                                {errors.category && <p>{errors.category.message}</p>}

                                            </div>
                                        </Col>






                                        {selectedCategory === 'GEN-EWS' && (


                                            <Col xs={12} md={3} >

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Family Income"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        {...register("income_amount")}
                                                        placeholder='Enter Income Amount' required
                                                    />
                                                </FloatingLabel>
                                                {errors.income_amount && <p>{errors.income_amount.message}</p>}
                                            </Col>

                                        )
                                        }

                                        {(selectedCategory === 'SC' || selectedCategory === 'ST' || selectedCategory === 'OBC' || selectedCategory === 'GEN-EWS') && (


                                            <Col xs={12} md={3} >

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Certificate No"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        {...register("caste_no")}
                                                        placeholder='Enter Caste No' required
                                                    />
                                                </FloatingLabel>
                                                {errors.caste_no && <p>{errors.caste_no.message}</p>}
                                            </Col>

                                        )
                                        }



                                        {(selectedCategory === 'SC' || selectedCategory === 'ST' || selectedCategory === 'OBC' || selectedCategory === 'GEN-EWS') && (

                                            <Col xs={12} md={3}>
                                                <div className='mb-3'>

                                                    {/* <Form.Label ><b>Date of Birth</b> </Form.Label> */}

                                                    <FloatingLabel
                                                        controlId="floatingInput"
                                                        label="Certificate Issue Date"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="date"
                                                            {...register("issue_date")}
                                                            placeholder='Select Date' required

                                                        /></FloatingLabel>
                                                    {errors.issue_date && <p>{errors.issue_date.message}</p>}

                                                </div>
                                            </Col>

                                        )
                                        }



                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Religion</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Religion"
                                                    className="mb-3"
                                                >
                                                    <Form.Select
                                                        {...register("religion")}
                                                    >
                                                        <option value="" >Select Religion</option>
                                                        <option value="Hindu">Hindu</option>
                                                        <option value="Muslim">Muslim</option>
                                                        <option value="Sikh">Sikh</option>
                                                        <option value="Christian">Christian</option>
                                                        <option value="Other">Other</option>
                                                    </Form.Select></FloatingLabel>
                                                {errors.religion && <p>{errors.religion.message}</p>}

                                            </div>
                                        </Col>




                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Marital Status</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Marital Status"
                                                    className="mb-3"
                                                >
                                                    <Form.Select
                                                        {...register("marital")}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Married">Married</option>
                                                        <option value="Unmarried">Unmarried</option>
                                                    </Form.Select></FloatingLabel>
                                                {errors.marital && <p>{errors.marital.message}</p>}

                                            </div>
                                        </Col>

                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>

                                                {/* <Form.Label ><b>Aadhar</b></Form.Label> */}

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Aadhar"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        {...register("adhar_num")}
                                                        type="number"
                                                        placeholder='Enter Aadhar Number'

                                                    /></FloatingLabel>
                                                {errors.adhar_num && <p>{errors.adhar_num.message}</p>}

                                            </div>
                                        </Col>



                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>

                                                {/* <Form.Label ><b>Mobile No.</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Mobile No."
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        {...register("mobile")}
                                                        type="number"
                                                        placeholder='Enter Mobile No.'

                                                    /></FloatingLabel>
                                                {errors.mobile && <p>{errors.mobile.message}</p>}

                                            </div>
                                        </Col>



                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>

                                                {/* <Form.Label ><b>Email</b> </Form.Label> */}

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Email"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="email"
                                                        placeholder='Enter Email'
                                                        {...register("email")}
                                                    /> </FloatingLabel>
                                                {errors.email && <p>{errors.email.message}</p>}

                                            </div>
                                        </Col>



                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>

                                                {/* <Form.Label ><b>Address</b> </Form.Label> */}

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Address"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="text"
                                                        placeholder='Address'
                                                        {...register("address")}
                                                    /></FloatingLabel>
                                                {errors.address && <p>{errors.address.message}</p>}

                                            </div>
                                        </Col>

                                        <Col xs={12} md={3}>
                                            <div className="mb-3">

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="State"
                                                    className="mb-3"
                                                >
                                                    <Form.Select
                                                        {...register("state")}

                                                        onChange={(e) => getDistrictByStateId(e)}
                                                    >
                                                        <option value="">Select State</option>
                                                        {
                                                            stateList && stateList.map((sm) =>
                                                                <option key={sm.id} value={sm.id} >{sm.state_name}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.state && <p>{errors.state.message}</p>}

                                            </div>
                                        </Col>




                                        <Col xs={12} md={3}>
                                            <div className="mb-3">

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="District"
                                                    className="mb-3"
                                                >
                                                    <Form.Select {...register("city")}

                                                        onChange={(e) => getSubDistrictByDistrictId(e)}

                                                    >
                                                        <option value="" >Select District</option>
                                                        {
                                                            cityList && cityList.map((cm) =>
                                                                <option key={cm.id} value={cm.id}>{cm.name}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.city && <p>{errors.city.message}</p>}

                                            </div>
                                        </Col>


                                        <Col xs={12} md={3}>
                                            <div className="mb-3">

                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Sub District"
                                                    className="mb-3"
                                                >
                                                    <Form.Select {...register("district")}
                                                    >
                                                        <option value="" >Select Sub-District</option>
                                                        {
                                                            subDistrictList && subDistrictList.map((cm) =>
                                                                <option key={cm.id} value={cm.id}>{cm.name}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.district && <p>{errors.district.message}</p>}

                                            </div>
                                        </Col>


                                        {/* <Col xs={12} md={3}>
                                            <div className='mb-3'>
                                       
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="District"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        {...register("district")}
                                                        type="text"
                                                        placeholder='Enter District Name'

                                                    /></FloatingLabel>
                                                {errors.district && <p>{errors.district.message}</p>}

                                            </div>
                                        </Col> */}


                                        <Col xs={12} md={3}>
                                            <div className='mb-3'>
                                                {/* 
                                                <Form.Label ><b>Pin Code</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Pin Code"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        {...register("pincode")}
                                                        type="pin"
                                                        placeholder='Enter Pin Code'

                                                    /></FloatingLabel>
                                                {errors.pincode && <p>{errors.pincode.message}</p>}

                                            </div>
                                        </Col>


                                    </Row>
                                </Card.Body>
                            </Card>







                            <Card className="mb-4">
                                <Card.Header><strong>Course Information</strong></Card.Header>
                                <Card.Body>

                                    <Row>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Course</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Course"
                                                    className="mb-3"
                                                >
                                                    <Form.Select
                                                        {...register("course")}
                                                        onChange={(e) => getAllMajorSubjectByCourse(e)}
                                                    >
                                                        <option value="" >Select Course</option>
                                                        {
                                                            coursecList && coursecList.map((a) =>
                                                                <option key={a.brc_id} data={a.id} value={a.id}>{a.course}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.course && <p>{errors.course.message}</p>}

                                            </div>
                                        </Col>


                                        {/* <h6 className="col-lg-3 col-md-4 label" id="major">Major Subject :</h6> */}


                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Subject 1 (Major Subject)</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Subject 1 (Major Subject)"
                                                    className="mb-3"
                                                >
                                                    <Form.Select
                                                        {...register("major_subfirst")}
                                                    >
                                                        <option value="" >Select Subject- 1</option>
                                                        {
                                                            majorList && majorList.map((ms) =>
                                                                <option key={ms.id} value={ms.id}>{ms.subject}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.major_subfirst && <p>{errors.major_subfirst.message}</p>}

                                            </div>
                                        </Col>

                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Subject 2 (Major Subject)</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Subject 2 (Major Subject)"
                                                    className="mb-3"
                                                >
                                                    <Form.Select

                                                        {...register("major_secund")}

                                                    >
                                                        <option value="" >Select Subject- 2</option>
                                                        {
                                                            majorList && majorList.map((ms) =>
                                                                <option key={ms.id} value={ms.id}>{ms.subject}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.major_secund && <p>{errors.major_secund.message}</p>}

                                            </div>
                                        </Col>



                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Subject 3 (Major Subject)</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Subject 3 (Major Subject)"
                                                    className="mb-3"
                                                >
                                                    <Form.Select
                                                        {...register("major_theard")}
                                                    >
                                                        <option value="">Select Subject- 3</option>
                                                        <option value="0">N/A</option>
                                                        {
                                                            majorList && majorList.map((ms) =>
                                                                <option key={ms.id} value={ms.id}>{ms.subject}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.major_theard && <p>{errors.major_theard.message}</p>}

                                            </div>
                                        </Col>





                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Subject (Minor Subject)</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Subject (Minor Subject)"
                                                    className="mb-3"
                                                >
                                                    <Form.Select {...register("minor_sub")}
                                                    >
                                                        <option value="">Select Minor Subject</option>
                                                        <option value="0">N/A</option>
                                                        {
                                                            minorList && minorList.map((ms) =>
                                                                <option key={ms.id} value={ms.id}>{ms.subject}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.minor_sub && <p>{errors.minor_sub.message}</p>}

                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Cocurricular Subject </b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Cocurricular Subject"
                                                    className="mb-3"
                                                >
                                                    <Form.Select

                                                        {...register("cocurricular_sub")}

                                                    >
                                                        <option value="">Select Cocurricular Subject</option>
                                                        <option value="0">N/A</option>
                                                        {
                                                            curricularSubject && curricularSubject.map((ms) =>
                                                                <option key={ms.id} value={ms.id}>{ms.subject}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.cocurricular_sub && <p>{errors.cocurricular_sub.message}</p>}

                                            </div>
                                        </Col>




                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Subject :(Vocational Course)</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Subject :(Vocational Course)"
                                                    className="mb-3"
                                                >
                                                    <Form.Select {...register("vocational_sub")}

                                                    >

                                                        <option value="" >Select Vocational Subject</option>
                                                        <option value="0">N/A</option>
                                                        {
                                                            vo_courseList && vo_courseList.map((cm) =>
                                                                <option key={cm.id} value={cm.id}>{cm.subject}</option>
                                                            )
                                                        }
                                                    </Form.Select></FloatingLabel>
                                                {errors.vocational_sub && <p>{errors.vocational_sub.message}</p>}

                                            </div>
                                        </Col>

                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label value="" ><b>Transfer Certificate</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Transfer Certificate"
                                                    className="mb-3"
                                                >
                                                    <Form.Select
                                                        {...register("tc")} required
                                                    >
                                                        <option value="0" >Select TC Status</option>
                                                        <option value="Available">Available</option>
                                                        <option value="Not-Available">Not-Available</option>
                                                    </Form.Select></FloatingLabel>
                                                {errors.tc && <p>{errors.tc.message}</p>}

                                            </div>
                                        </Col>

                                    </Row>
                                </Card.Body>
                            </Card>



                            <Card className="mb-4">
                                <Card.Header><strong>Upload Documents</strong></Card.Header>
                                <Card.Body>

                                    <Row>

                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>High School Marksheet</b></Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="High School Marksheet"
                                                    className="mb-3"
                                                >
                                                    <Form.Control type="file" id="fileInput" {...register("highschool")} required
                                                    /></FloatingLabel>
                                                {errors.highschool && <p>{errors.highschool.message}</p>}

                                            </div>
                                        </Col>

                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Intermediate Marksheet</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Intermediate Marksheet"
                                                    className="mb-3"
                                                >
                                                    <Form.Control type="file" id="fileInput1" {...register("inter")} required
                                                    /></FloatingLabel>
                                                {errors.inter && <p>{errors.inter.message}</p>}

                                            </div>
                                        </Col>


                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Aadhar Upload</b> </Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Aadhar Upload"
                                                    className="mb-3"
                                                >
                                                    <Form.Control type="file" id="fileInput2" {...register("adhar")} required
                                                    /></FloatingLabel>
                                                {errors.adhar && <p>{errors.adhar.message}</p>}

                                            </div>
                                        </Col>

                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Image Upload</b></Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Image Upload"
                                                    className="mb-3"
                                                >
                                                    <Form.Control type="file" id="fileInput3" {...register("photo")} required
                                                    /></FloatingLabel>
                                                {errors.photo && <p>{errors.photo.message}</p>}

                                            </div>
                                        </Col>

                                    </Row>

                                    <Row>

                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Signature Upload</b></Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Signature Upload"
                                                    className="mb-3"
                                                >
                                                    <Form.Control type="file" id="fileInput4" {...register("signature")} required
                                                    /></FloatingLabel>
                                                {errors.signature && <p>{errors.signature.message}</p>}

                                            </div>
                                        </Col>




                                        <Col xs={12} md={3}>
                                            <div className="mb-3">
                                                {/* <Form.Label ><b>Signature Upload</b></Form.Label> */}
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Domicile Certificate"
                                                    className="mb-3"
                                                >
                                                    <Form.Control type="file" {...register('domicile')} required
                                                    /></FloatingLabel>
                                                {errors.domicile && <p>{errors.domicile.message}</p>}

                                            </div>

                                        </Col>







                                        {(selectedCategory === 'SC' || selectedCategory === 'ST' || selectedCategory === 'OBC') && (
                                            <Col xs={12} md={3}>
                                                <div className="mb-3">

                                                    <FloatingLabel
                                                        controlId="floatingInput"
                                                        label="Caste Certificate"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control type="file" {...register('caste')} required
                                                        /></FloatingLabel>
                                                    {errors.caste && <p>{errors.caste.message}</p>}

                                                </div>
                                            </Col>
                                        )
                                        }


                                        {selectedCategory === 'GEN-EWS' && (

                                            <Col xs={12} md={3}>


                                                <div className="mb-3">
                                                    {/* <Form.Label ><b>Signature Upload</b></Form.Label> */}
                                                    <FloatingLabel
                                                        controlId="floatingInput"
                                                        label="EWS Certificate"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control type="file" {...register('income')} required
                                                        /></FloatingLabel>
                                                    {errors.income && <p>{errors.income.message}</p>}

                                                </div>

                                            </Col>



                                        )
                                        }

                                        {selectedTC === 'Available' && (

                                            <Col xs={12} md={3}>


                                                <div className="mb-3">
                                                    {/* <Form.Label ><b>Signature Upload</b></Form.Label> */}
                                                    <FloatingLabel
                                                        controlId="floatingInput"
                                                        label="Transfer Certificate"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control type="file" {...register('transfer')} required
                                                        /></FloatingLabel>
                                                    {errors.transfer && <p>{errors.transfer.message}</p>}

                                                </div>

                                            </Col>



                                        )
                                        }





                                        <Col xs={12} md={3}>

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={3}></Col>
                                        <Col xs={12} md={3}></Col>
                                        <Col xs={12} md={3}></Col>

                                        <Col xs={12} md={3}>

                                            <Button type='submit' color="primary" size="xl" style={{ marginTop: 13, float: "right" }}

                                            >Submit</Button>
                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>
                        </Form>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
export default AdmissionForm;